$('#control-next').click(function(){
    $('#service-carousel .prev').addClass('left');
    $('#service-carousel .selected').addClass('middle');
    $('#service-carousel .next').addClass('right');

    $('.left').addClass('next');
    $('.middle').addClass('prev');
    $('.right').addClass('selected');

    $('.left').removeClass('prev');
    $('.middle').removeClass('selected');
    $('.right').removeClass('next');

    $('.next').removeClass('left');
    $('.prev').removeClass('middle');
    $('.selected').removeClass('right');
});

$('#control-prev').click(function(){
    $('.prev').addClass('left');
    $('.selected').addClass('middle');
    $('.next').addClass('right');

    $('.left').addClass('selected');
    $('.middle').addClass('next');
    $('.right').addClass('prev');

    $('.left').removeClass('prev');
    $('.middle').removeClass('selected');
    $('.right').removeClass('next');

    $('.next').removeClass('middle');
    $('.prev').removeClass('right');
    $('.selected').removeClass('left');
});

/**
$('#service-carousel>div').on('swipeleft', function() {
    $('.prev').addClass('left');
    $('.selected').addClass('middle');
    $('.next').addClass('right');

    $('.left').addClass('selected');
    $('.middle').addClass('next');
    $('.right').addClass('prev');

    $('.left').removeClass('prev');
    $('.middle').removeClass('selected');
    $('.right').removeClass('next');

    $('.next').removeClass('middle');
    $('.prev').removeClass('right');
    $('.selected').removeClass('left');
});

$('#service-carousel>div').on("swiperight", function() {
    $('.prev').addClass('left');
    $('.selected').addClass('middle');
    $('.next').addClass('right');

    $('.left').addClass('next');
    $('.middle').addClass('prev');
    $('.right').addClass('selected');

    $('.left').removeClass('prev');
    $('.middle').removeClass('selected');
    $('.right').removeClass('next');

    $('.next').removeClass('left');
    $('.prev').removeClass('middle');
    $('.selected').removeClass('right');
});
 */